import styled from 'styled-components';
import { BP_TABLET_MAX, BP_MOBILE_MAX } from '../../assets/styles/breakpoints';

export default styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  @media (max-width: ${BP_TABLET_MAX}px) {
    max-width: 560px;
    margin: 0 auto;
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
    max-width: 100%;
    margin: 0 auto;
  }
`;

export const TopContentWrapSC = styled.div`
  padding-bottom: 16px;
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const TableInvestsContentWrapSC = styled.div`
  width: 100%;
`;

export const TableOffersContentWrapSC = styled.div`
  padding-top: 32px;
  width: 100%;
`;
